(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('type-patient-contacts-relationship', {
                parent: 'entity',
                url: '/type-patient-contacts-relationship',
                data: {
                    authorities: [],
                    pageTitle: 'TypePatientContactsRelationships'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/type-patient-contacts-relationship/list/type-patient-contacts-relationships.html',
                        controller: 'TypePatientContactsRelationshipController',
                        controllerAs: 'vm'
                    }
                },
                ncyBreadcrumb: {
                    label: 'Patient Contacts Relationship Types'
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_PATIENT_CONTACTS_RELATIONSHIP];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_TYPE_PATIENT_CONTACTS_RELATIONSHIP, access);
                }]
            });
    }
})();
